const BUSINESS_TYPES = [
  {
    label: "Jordbrukshandlare / Lantbruksbutik",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Djurhem / Välgörenhet",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Uppfödningsplats",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Nötköttproducent",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Slaktkycklingar", value: "Broilers", id: "broilers" },
  {
    label: "Inköpsgrupp",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kalvproduktion",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kalvgård/Utvecklare",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Nötkreatursköpare", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Kontraktsodlare",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Kooperativ", value: "Cooperative", id: "cooperative" },
  {
    label: "Huvudkontor",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Ko/Kalv-operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Mjölkproduktion",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributör / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Foderkvarn", value: "Feed Mill", id: "feed_mill" },
  { label: "Fodergård", value: "Feedyard", id: "feedyard" },
  {
    label: "Odlare/Odlingsgård",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Kläckeri", value: "Hatchery", id: "hatchery" },
  {
    label: "Kvigproduktion",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Värphönsintegration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Värphöns", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Mjölkkooperativ/Köpare",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Blandad/Annan Producent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Näringsämnesleverantör",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Förpackare/Bearbetare",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Djuraffär",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotek", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Fjäderfäuppfödare",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Fjäderfäintegratör",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Fårproducent", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Ungnötsoperation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Kreatursgård/Auktionshall",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Grisproducent", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkoner", value: "Turkeys", id: "turkeys" },
  {
    label: "Universitet / Utbildning",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinärpraktik",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Grossist / Återförsäljare",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Ullköpare", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obligatoriskt",
    },
  },
  salutation: {
    label: "Tilltal",
    placeholder: "Välj tilltal",
    errors: {
      required: "Tilltal krävs",
      invalid: "Välj ett giltigt tilltal",
    },
  },
  firstName: {
    label: "Förnamn",
    placeholder: "John",
    errors: {
      required: "Förnamn krävs",
      minLength: "Förnamn måste vara minst 2 tecken",
      maxLength: "Förnamn får vara högst 50 tecken",
    },
  },
  lastName: {
    label: "Efternamn",
    placeholder: "Doe",
    errors: {
      required: "Efternamn krävs",
      minLength: "Efternamn måste vara minst 2 tecken",
      maxLength: "Efternamn får vara högst 50 tecken",
    },
  },
  email: {
    label: "E-post",
    placeholder: "john.smith@example.org",
    description:
      "Ange en e-postadress som är personlig för dig, inte en delad e-postadress.",
    prefixWarningTitle: "Delad brevlåda upptäckt",
    prefixWarningDescription:
      "Vi rekommenderar att du använder en personlig e-postadress för en överlägsen personlig upplevelse",
    errors: {
      required: "E-post krävs",
      invalidEmail: "Ange en giltig e-postadress",
      emailAssociatedWithYourAccount:
        "Din e-postadress är kopplad till ditt konto och kan inte ändras.",
    },
  },
  confirmEmail: {
    label: "Bekräfta e-post",
    placeholder: "john.smith@example.org",
    errors: {
      required: "Bekräfta e-post krävs",
      invalidEmail: "Ange en giltig e-postadress",
      emailMatchError: "E-postadresserna stämmer inte överens",
    },
  },
  password: {
    label: "Lösenord",
    placeholder: "Ange ditt lösenord",
    errors: {
      required: "Lösenord krävs",
    },
  },
  confirmPassword: {
    label: "Bekräfta lösenord",
    placeholder: "Bekräfta ditt lösenord",
    errors: {
      required: "Bekräfta lösenord krävs",
      passwordMatchError: "Lösenorden stämmer inte överens",
    },
  },
  addressLine1: {
    label: "Adressrad 1",
    placeholder: "123 Main St",
    errors: {
      required: "Adressrad 1 krävs",
      minLength: "Adressrad 1 måste vara minst 5 tecken",
      maxLength: "Adressrad 1 får vara högst 100 tecken",
    },
  },
  addressLine2: {
    label: "Adressrad 2",
    placeholder: "Lgh 4B",
    errors: {
      required: "Adressrad 2 krävs",
      maxLength: "Adressrad 2 får vara högst 100 tecken",
    },
  },
  city: {
    label: "Stad / Ort",
    placeholder: "Stockholm",
    errors: {
      required: "Stad / Ort krävs",
      minLength: "Stad / Ort måste vara minst 2 tecken",
      maxLength: "Stad / Ort får vara högst 50 tecken",
    },
  },
  state: {
    label: "Län",
    placeholder: "Välj län",
    errors: {
      required: "Län krävs",
      invalid: "Välj ett giltigt län",
    },
  },
  jurisdiction: {
    label: "Licensjurisdiktion",
    placeholder: "Välj licensjurisdiktion",
    errors: {
      required: "Licensjurisdiktion krävs",
      invalid: "Välj en giltig jurisdiktion",
    },
  },
  zipCode: {
    label: "Postnummer",
    placeholder: "12345",
    errors: {
      required: "Postnummer krävs",
      invalid: "Ange ett giltigt postnummer",
    },
  },
  role: {
    label: "Roll",
    placeholder: "Välj din roll",
    errors: {
      required: "Välj din roll",
      invalid: "Välj en giltig roll",
    },
  },
  businessType: {
    label: "Företagstyp",
    placeholder: "Välj företagstyp",
    errors: {
      required: "Företagstyp krävs",
      invalid: "Välj en giltig företagstyp",
    },
  },
  businessName: {
    label: "Företagsnamn",
    placeholder: "Ange företagsnamn",
    errors: {
      required: "Företagsnamn krävs",
      minLength: "Företagsnamn måste vara minst 2 tecken",
      maxLength: "Företagsnamn får vara högst 100 tecken",
    },
  },
  businessSearch: {
    label: "Företagssökning:",
    addNewAccount: "Lägg till nytt företagskonto",
    canNotFindBusiness: "Kan du inte hitta ditt företag?",
    guideline: "Ange ditt postnummer och välj sedan från listan nedan.",
    guidelineForNameSearch:
      "Ange fullständigt företagsnamn och välj sedan från listan.",
    placeholder: "Var arbetar du?",
    noResults: "Inga resultat hittades",
    searching: "Söker...",
    selectedBusinessHeading: "Valt företag:",
    selectedBusinessNotCorrect: "Inte korrekt?",
    selectedBusinessTryAgain: "Försök igen",
    selectedBusinessDismiss: "Avvisa företag",
    resultsFound: {
      singular: "1 företag hittades",
      plural: "Flera företag hittades",
    },
    errors: {
      network:
        "Vi har problem med att ansluta till företagssökaren. Försök igen senare.",
    },
  },
  explicitConsent: {
    label:
      "Genom att markera den här rutan godkänner jag Elancos användningsvillkor och bekräftar att Elanco kommer att samla in och behandla min personliga information i enlighet med Elancos integritetsmeddelande",
    errors: {
      required: "E-postsamtycke krävs",
    },
  },
  telephone: {
    label: "Personligt telefonnummer",
    placeholder: "Ange ditt personliga telefonnummer",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Sök land…",
    errors: {
      invalid: "Ange ett giltigt telefonnummer.",
    },
  },
  businessTelephone: {
    label: "Företagstelefon",
    placeholder: "Ange ditt företagstelefonnummer",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Sök land…",
    errors: {
      invalid: "Ange ett giltigt telefonnummer.",
    },
  },
  professionalNumber: {
    label: "Professionsnummer",
    placeholder: "1234567",
    errors: {
      required: "Ange ett professionsnummer",
      maxLength: "Inmatningen överskrider teckengränsen",
    },
  },
  addressSearch: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  businessSearchField: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  checkbox: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  combobox: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  datePicker: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  dateRange: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  dateTime: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  emailField: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  fileInput: {
    errors: {
      required: "Välj en fil",
    },
  },
  number: {
    errors: {
      required: "Ange ett nummer",
      minValue: "Ange ett värde högre än minimum",
      maxValue: "Ange ett värde lägre än maximum",
    },
  },
  passwordField: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  rangeSlider: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  select: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  telephoneField: {
    errors: {
      required: "Ange endast siffror",
      invalidTelephone: "Ange ett giltigt telefonnummer",
      invalidFormat: "Ogiltigt nummerformat",
    },
  },
  text: {
    errors: {
      required:
        "Använd endast bokstäver (A-Ö), siffror (0-9) och inga symboler",
      maxLength: "Inmatningen överskrider teckengränsen",
      minLength: "Inmatningen måste vara minst 2 tecken",
    },
  },
  textarea: {
    characters: "tecken",
  },
  time: {
    errors: {
      required: "Detta fält är obligatoriskt",
    },
  },
  form: {
    errors: {
      generic:
        "Vi stötte på ett fel när vi skickade in ditt formulär. Försök igen.",
      reportAnIssue: "Rapportera ett problem.",
      configuration: "Konfigurationsfel",
      noFormQuestionsAvailable: "Inga formulärfrågor tillgängliga.",
      formComponentLoad:
        "Formulärkomponent kunde inte laddas på grund av ett fält som inte stöds.",
      code: "Kod",
      type: "Typ",
      missingRequiredFields:
        "Detta formulär saknar obligatoriska fält (e-post och/eller samtycke). Kontakta en administratör för att åtgärda formulärkonfigurationen.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Akademiker", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Djurvälfärd - Övrigt",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Djurvälfärd - Butikspersonal",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Djurvälfärd - Veterinär",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Djurvälfärd - Veterinärsjuksköterska",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Djurvälfärd - Volontär",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Nötkött / Fodergård Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Nötköttproducent",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Uppfödare", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Företagsadministratör / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Företagsägare / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Konsulterande nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Företagsanställd veterinär (ej sjukhus)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Mjölkproducent",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributör", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributörsrepresentant, fältbaserad",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributörsrepresentant, intern",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Utbildningsinstitution - Gymnasieelev",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Utbildningsinstitution - Yrkeshögskolestudent",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Utbildningsinstitution - Universitetsstudent",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medicinsk/Klinikchef",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Näring / Foderförsäljning",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Näringsprofessionell",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kontor/Praktikchef",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC-återförsäljare", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apotekare", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotek - Personal",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Grisproducent", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Fjäderfäproducent",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praktikägare, ej veterinär",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Kundservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Återförsäljarbutik - Personal",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinär",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Tränare", id: "trainer" },
  { value: "Veterinarian", label: "Veterinär", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinär, praktikägare",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinärassistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinärsjuksköterska",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinärpraktik - Övrigt",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinärpraktik - Veterinär",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinärpraktik - Veterinärsjuksköterska",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinärspecialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinärstudent",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinärkirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinärtekniker",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Grossist", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Fröken",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Herr",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Fru",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Fru/Fröken",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
